module.exports = __webpack_public_path__ + "static/media/youtube.465f06f3.svg";